import React from "react";
import { CardElement } from "@stripe/react-stripe-js";
import DialogBox from "../util/DialogBox";
import SavedCards from "./SavedCards";
import { priceOfCart } from "../util/Util";
import { useTranslation } from "react-i18next";

function PaymentForm({ cart }) {
  const { t } = useTranslation();
  const savedCards = [];

  const showPaymentUnavailable = () => {
    DialogBox({
      text: t("errorPayment"),
      icon: "error",
      confirmButtonText: "OK",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("jest: handleSubmit appelé");
    showPaymentUnavailable();
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <div className="container mt-4 card mb-4 mb-xl-0 shadow pt-4 pb-4">
            <h3 className="card-title text-center">{t("cartPayment")}</h3>
            <p className="card-text text-center">{t("enjoyCart")}</p>
            <h5 className="card-text text-center">
              Total {"(" + priceOfCart(cart) + ")"} €
            </h5>
            <form onSubmit={handleSubmit} className="formCard">
              <div className="form-group">
                <label
                  id="card-info-label"
                  className="fw-bolder pb-2"
                  aria-label="Informations de la carte"
                >
                  {t("cardInformations")}
                </label>
                <div id="card-info" aria-labelledby="card-info-label">
                  <CardElement className="form-control" />
                </div>
              </div>
              <br />
              <button type="submit" className="btn btn-success">
                {t("pay")}
              </button>
            </form>
          </div>
        </div>
        <div className="col-md-6">
          <SavedCards
            savedCards={savedCards}
            handlePayWithSavedCard={showPaymentUnavailable}
            handleRemoveSavedCard={showPaymentUnavailable}
            hidePaymentButton={false}
            hidePaymentFormButton={false}
          />
        </div>
      </div>
    </div>
  );
}

export default PaymentForm;
